import { useGetSearchParam } from '@/hooks'
import { ENDPOINTS } from '@/util'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { PageResponse } from './types'
// import { json } from '../../mock-data/page-layout/page-layout.json'

// const pageResponse = json as PageResponse

interface GetAppPageParams {
  appKey?: string
  pageId?: string
  projectId?: number
}
const getAppPage = async ({ appKey, pageId, projectId }: GetAppPageParams) => {
  console.log('appKey', appKey)
  console.log('pageId', pageId)
  console.log('projectId', projectId)
  if (!appKey || !pageId || !projectId) {
    throw new Error('Missing required parameters')
  }
  // return Promise.resolve(pageResponse.uiSchema)
  const url = `${ENDPOINTS.CC}/content`
  const response = await fetch(url, {
    method: 'POST',
    headers: { 'Content-type': 'application/json' },
    body: JSON.stringify({
      app_id: appKey,
      content_id: pageId,
      project_id: projectId,
      filters: [],
    }),
  })
  const data = await response.json()
  if (response.ok) {
    return (data as PageResponse).uiSchema
  }
  throw new Error('Failed to fetch app page')
}

export function useGetAppPage() {
  const { appKey, page, '*': splat } = useParams()
  console.log(`const { appKey, page, '*': splat } = useParams()`, appKey, page, splat)
  const projectId = useGetSearchParam<number>('projectId')
  const pageId = `/${appKey}/pages/${page}${splat ? `/${splat}` : ''}`
  console.log('pageId', `/${appKey}/pages/${page}${splat ? `/${splat}` : ''}`)
  return useSuspenseQuery({
    queryKey: [pageId, appKey, projectId],
    queryFn: () => getAppPage({ appKey, pageId, projectId }),
    // 24 hour stale time
    staleTime: 1000 * 60 * 60 * 24,
  })
}
